export const widgetConfig = {
    hotelId: '',
    ticker: '',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 2,
    currency: 'EUR',
    baseUrl: '',
    urlChain: '',
    urlHotel: '',
    showChildAges: false,
};
